<template>
  <v-app>
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
import side from "@/components/The_Sidebar.vue";

export default {
  name: "App",
  components: {
    side,
  },
  data: () => ({
    barswitch: false,
    selectedItem: 0,
    items: [
      { text: "關於我們", link: "/about" },
      { text: "最新消息" },
      { text: "房型介紹" },
      { text: "線上訂房" },
      { text: "交通資訊​" },
    ],
    direction: "top",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: "scale-transition",
  }),
};
</script>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s, transform 1s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
</style>
